var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7998 1.4C4.7998 0.626801 5.42661 0 6.1998 0H10.1998C10.973 0 11.5998 0.626802 11.5998 1.4V6.8H4.7998V1.4ZM6.7998 2V4.8H9.5998V2H6.7998Z",
    fill: "#2990FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7998 5.7998H10.5998V10.5998H5.7998V5.7998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7998 4.7998H11.5998V11.5998H4.7998V4.7998ZM6.7998 6.7998V9.5998H9.5998V6.7998H6.7998Z",
    fill: "#2990FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7998 10.5996H10.5998V15.3996H5.7998V10.5996Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7998 9.59961H11.5998V16.3996H4.7998V9.59961ZM6.7998 11.5996V14.3996H9.5998V11.5996H6.7998Z",
    fill: "#2990FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7998 15.4004H10.5998V19.8004C10.5998 20.0213 10.4207 20.2004 10.1998 20.2004H6.1998C5.97889 20.2004 5.7998 20.0213 5.7998 19.8004V15.4004Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7998 14.4004H11.5998V19.8004C11.5998 20.5736 10.973 21.2004 10.1998 21.2004H6.1998C5.42661 21.2004 4.7998 20.5736 4.7998 19.8004V14.4004ZM6.7998 16.4004V19.2004H9.5998V16.4004H6.7998Z",
    fill: "#2990FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.9996C1 10.7787 1.17909 10.5996 1.4 10.5996H5.8V15.3996H1.4C1.17909 15.3996 1 15.2205 1 14.9996V10.9996Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.9996C0 10.2264 0.626802 9.59961 1.4 9.59961H6.8V16.3996H1.4C0.626801 16.3996 0 15.7728 0 14.9996V10.9996ZM2 11.5996V14.3996H4.8V11.5996H2Z",
    fill: "#2990FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 15.4004H20.1999V20.2004H15.3999V15.4004Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3999 14.4004H21.1999V21.2004H14.3999V14.4004ZM16.3999 16.4004V19.2004H19.1999V16.4004H16.3999Z",
    fill: "#2990FB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 20.2002H20.1999V24.6002C20.1999 24.8211 20.0208 25.0002 19.7999 25.0002H15.7999C15.579 25.0002 15.3999 24.8211 15.3999 24.6002V20.2002Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3999 19.2002H21.1999V24.6002C21.1999 25.3734 20.5731 26.0002 19.7999 26.0002H15.7999C15.0267 26.0002 14.3999 25.3734 14.3999 24.6002V19.2002ZM16.3999 21.2002V24.0002H19.1999V21.2002H16.3999Z",
    fill: "#2990FB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6001 10.5996H15.4001V15.3996H10.6001V10.5996Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6001 9.59961H16.4001V16.3996H9.6001V9.59961ZM11.6001 11.5996V14.3996H14.4001V11.5996H11.6001Z",
    fill: "#2990FB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 6.1998C15.3999 5.97889 15.579 5.7998 15.7999 5.7998H19.7999C20.0208 5.7998 20.1999 5.97889 20.1999 6.1998V10.5998H15.3999V6.1998Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3999 6.1998C14.3999 5.42661 15.0267 4.7998 15.7999 4.7998H19.7999C20.5731 4.7998 21.1999 5.42661 21.1999 6.1998V11.5998H14.3999V6.1998ZM16.3999 6.7998V9.5998H19.1999V6.7998H16.3999Z",
    fill: "#2990FB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 10.5996H20.1999V15.3996H15.3999V10.5996Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3999 9.59961H21.1999V16.3996H14.3999V9.59961ZM16.3999 11.5996V14.3996H19.1999V11.5996H16.3999Z",
    fill: "#2990FB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2002 10.5996H24.6002C24.8211 10.5996 25.0002 10.7787 25.0002 10.9996V14.9996C25.0002 15.2205 24.8211 15.3996 24.6002 15.3996H20.2002V10.5996Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2002 9.59961H24.6002C25.3734 9.59961 26.0002 10.2264 26.0002 10.9996V14.9996C26.0002 15.7728 25.3734 16.3996 24.6002 16.3996H19.2002V9.59961ZM21.2002 11.5996V14.3996H24.0002V11.5996H21.2002Z",
    fill: "#2990FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossword);
export default __webpack_public_path__ + "static/media/crossword.25003b78f31efc1df616445758831104.svg";
export { ForwardRef as ReactComponent };